import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ConfigurationService } from './configuration.service';

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json; charset=UTF-8',
    'Accept': 'application/json',
    'Access-Control-Allow-Origin': '*'
  })
};

const formHttpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
    'Accept': 'application/json',
    'Access-Control-Allow-Origin': '*'
  })
};

@Injectable({
  providedIn: 'root',
})
export class PasswordResetService {
  private apiUrl: string = '';

  constructor(
    private http: HttpClient,
    private configurationService: ConfigurationService
  ) {
    this.apiUrl = this.configurationService.config.apiAddress;
    this.configurationService.configData$.subscribe(res => {
      this.apiUrl = res.apiAddress;
    })
  }

  requestPasswordResetLink(emailAddress: string) {
    let body = `emailAddress=${emailAddress}&sourceApplication=Portal`;
    return this.http.post(this.apiUrl + 'api/Password/forgot-password-reset', body, formHttpOptions);
  }

  updatePassword(password: string, resetToken: string) {
    let encodedToken = encodeURIComponent(resetToken);
    return this.http.post(this.apiUrl + 'api/Password/forget-password-update?token=' + encodedToken, JSON.stringify(password), httpOptions);
  }
}
